import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "small-table" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "p-detail" }
const _hoisted_4 = { class: "buttons" }

import { ServiceItem } from "@/services/entities/ServiceItem";
import { useSettingsStore } from "@/stores/setting";
import { formatLocaleDate } from "@/common/date";
import DxButton from 'devextreme-vue/button';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceDetail',
  props: {
    service: { Type: {} as ServiceItem, default: {} as ServiceItem }
},
  emits: ['edit', 'delete'],
  setup(__props, { emit: __emit }) {

const settingsStore = useSettingsStore();
const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "title" }, "Service detail", -1)),
      _createVNode(_unref(DxButton), {
        icon: "trash",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete', props.service.id)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Service Name", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.blServiceName), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "BL PG Code", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.blpgCode), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Sales order", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.mxSalesOrder), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Order value (USD)", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.orderValue), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("span", null, "Invoice address", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.invoiceAddress), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "SAP number", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.sapNumber), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[9] || (_cache[9] = _createElementVNode("span", null, "PO number", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.poNumber), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Operations manager", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.operationsManager), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Valid from", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(formatLocaleDate)(props.service.validFrom)), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Valid to", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(formatLocaleDate)(props.service.validTo)), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("span", null, "Division", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(settingsStore).getDivisions.find(a => a.id == props.service.divisionId)?.name), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Country", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(settingsStore).getCountries.find(a => a.id == props.service.countryId)?.name), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Link", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.link), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Description", -1)),
        _createElementVNode("span", null, _toDisplayString(props.service.description), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('edit', props.service.id)))
      }, "Edit")
    ])
  ]))
}
}

})